import {ROUTES_PATHS} from "./routes";
import {EnvironmentEnum} from "../enums/environment.enum";

export const menuItemsSidebarBo = [
	{
		label: 'Mes informations personnelles',
		path: ROUTES_PATHS.MON_COMPTE,
		picto: 'mes_infos',
		environment: [EnvironmentEnum.DEV, EnvironmentEnum.PROD],
		roles: []
	},
	{
		label: 'Mes agences',
		path: ROUTES_PATHS.AGENCES,
		picto: 'agences',
		environment: [EnvironmentEnum.DEV, EnvironmentEnum.PROD],
		roles: [-1, 1, 2]
	},
	{
		label: 'Mes agents immobiliers',
		path: ROUTES_PATHS.AGENTS,
		picto: 'agents',
		environment: [EnvironmentEnum.DEV, EnvironmentEnum.PROD],
		roles: [-1, 1, 2]
	},
	{
		label: 'Mes clients',
		path: ROUTES_PATHS.CLIENTS,
		picto: 'clients',
		environment: [EnvironmentEnum.DEV, EnvironmentEnum.PROD],
		roles: [-1, 1, 2]
	},
	{
		label: 'Mes estimations',
		path: ROUTES_PATHS.ESTIMATIONS,
		picto: 'estimations',
		environment: [EnvironmentEnum.DEV, EnvironmentEnum.PROD],
		roles: []
	},
	{
		label: 'Gestion des utilisateurs',
		path: ROUTES_PATHS.ALL_USERS,
		picto: 'settings_users',
		environment: [EnvironmentEnum.DEV, EnvironmentEnum.PROD],
		roles: [-1]
	}
]
